import { render, staticRenderFns } from "./borrower-detail.component.vue?vue&type=template&id=b02e3600&scoped=true"
import script from "./borrower-detail.component.vue?vue&type=script&lang=ts"
export * from "./borrower-detail.component.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=b02e3600&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02e3600",
  null
  
)

export default component.exports